/**
 * This file is our entrypoint, so we need to import bootstrap.js, our async
 * boundary.
 * Read more:
 * https://webpack.js.org/concepts/module-federation/#troubleshooting
 */
import('./bootstrap');

export {};
